import React from 'react';
import history from '../../../../history';
import cancelEvent from '../../../../services/mini/cancelEvent';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import RenameTestConversationForm from '../RenameTestConversationForm/RenameTestConversationForm';
import NewTestConversationForm from '../NewTestConversationForm/NewTestConversationForm';
import { Container, Draggable } from 'react-smooth-dnd';
import applyDrag from '../../../../services/mini/applyDrag';
import getArrayHash from '../../../../services/mini/getArrayHash';
import ExportImportTestCasesPanel from '../ExportImportTestCasesPanel/ExportImportTestCasesPanel';
import ProgressLoader from '../../../components/ProgressLoader/ProgressLoader';
import ProjectLeftPanel from '../../../components/ProjectLeftPanel/ProjectLeftPanel';
import GitHubIntegrationWrapper from '../../../components/GitHubIntegrationWrapper/GitHubIntegrationWrapper';
import ProjectLeftPanelAddBtn from '../../../components/ProjectLeftPanel/ProjectLeftPanelAddBtn';
import ProjectLeftPanelBottomPanel from '../../../components/ProjectLeftPanel/ProjectLeftPanelBottomPanel';
import ProjectLeftPanelTitle from '../../../components/ProjectLeftPanel/ProjectLeftPanelTitle';
import ProjectLeftPanelList from '../../../components/ProjectLeftPanel/ProjectLeftPanelList';
import ProjectLeftPanelListItem from '../../../components/ProjectLeftPanel/ProjectLeftPanelListItem';
import Menu from '../../../components/Menu/Menu';
import device from '../../../../services/mini/device';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/projects/actions.projects';
import * as testModeActions from '../../../../redux/testMode/actions.testMode';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import GitHubRepoPanel from '../GitHubIntegration/GitHubRepoPanel/GitHubRepoPanel';
import { Environment } from '../../../../const/environment';
import projectHelper from '../../../../services/ProjectHelper';
import capitalize from '../../../../services/mini/capitalize';
import RunAllButton from '../TestMode/RunAllButton/RunAllButton';
import FilterSwitcher from '../../../components/FilterSwitcher/FilterSwitcher';

class ConversationItem extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { conversation } = this.props;

        this.state = {
            highlightAsImported: conversation.imported,
            treeExporting: false
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const curProps = this.props;

        if (curProps.conversation && nextProps.conversation &&
            !curProps.conversation.imported && nextProps.conversation.imported) {
            this.setState({ highlightAsImported: true });
        }
    }

    renameConversation = (e) => {
        const { conversation } = this.props;
        this.props.renameConversation(conversation, e);
    }

    deleteConversation = (e) => {
        const { conversation } = this.props;
        this.props.deleteConversation(conversation, e);
    }

    runDialog = (e) => {
        const { conversation, runDialog, refreshingDialogs, stopDialog } = this.props;

        const isRefreshingNow = this.isRefreshing();

        let { highlightAsImported } = this.state;
        if (isRefreshingNow) {
            stopDialog();
        } else {
            runDialog({ conversationId: conversation.id });
        }
    }


    goToConversation = (e) => {
        const { conversation } = this.props;
        this.props.goToConversation(conversation.name, e);
    }

    markImportedItemAsSeen = () => {
        if (this.state.highlightAsImported) {
            this.setState({ highlightAsImported: false });
        }
    }

    isRefreshing = () => {
        let {
            conversation,
            refreshingDialogs
        } = this.props;

        const dialogIds = Object.keys(refreshingDialogs);

        let result = false;

        for (let i = 0; i < dialogIds.length; i++) {
            if (refreshingDialogs[dialogIds[i]]?.conversationId === conversation.id) {
                result = true;
                break;
            }

        }

        return result;
    }

    render() {
        let {
            conversation,
            dialogsInfo
        } = this.props;

        const conversationInfo = dialogsInfo[conversation?.id] || {};

        const failedDialogs = conversationInfo?.failed;
        const passedDialogs = conversationInfo?.passed;

        let { highlightAsImported } = this.state;

        const isRefreshingNow = this.isRefreshing();

        return <div onClick={this.goToConversation}
            onMouseOver={this.markImportedItemAsSeen}
            className={`test-cases-panel_conversations_list_item ${highlightAsImported && 'imported'}`}>
            <span className="test-cases-panel_conversations_list_item_name">
                {conversation.name}
                <div className="test-cases-panel_conversations_list_item_info">
                    {failedDialogs > 0 ? <span className="failed"><i className="icon icon-warning-toster" /> {failedDialogs} failed </span> : <></>}
                    {passedDialogs > 0 ? <span className="passed"><i className="icon icon-alan-test-check" />{passedDialogs} passed </span> : <></>}

                </div>
            </span>
            <Menu fixed={device.isDesktop() ? true : false}>
                <div onClick={this.runDialog} className="test-cases-panel_conversations_list_item run-dialogs-item">

                    {isRefreshingNow ? <>
                        <i className="icon icon-alan-stop-intent" />Stop dialog(s)
                    </> : <>
                        <i className="icon icon-alan-triangle-right" />Run dialog(s)</>}
                </div>
                <div onClick={this.renameConversation}>
                    <i className="icon icon-alan-edit" />Rename
                </div>
                <div onClick={this.deleteConversation}>
                    <i className="icon icon-alan-trash" />Delete
                </div>
            </Menu>
        </div>;
    }
}

class TestCasesPanel extends React.Component {
    constructor(props, context) {
        super(props, context);

        const { project } = this.props;

        this.state = {
            conversations: (project && project.conversations) ? project.conversations : []
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.project && nextProps.project.conversations) {
            this.setState({ conversations: nextProps.project.conversations });
        }
    }

    componentWillUnmount() {
        this.props.stopDialog();
        this.props.stopRunningDialogs();
    }

    renameConversation = (conversation, e) => {
        let { project } = this.props;
        let projectId = project.projectId;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <RenameTestConversationForm
                        project={project}
                        conversationName={conversation.name}
                        renameConversation={(name) => {
                            this.props.updateTestConversation({
                                projectId,
                                conversationId: conversation.id,
                                name
                            });
                        }}
                        onClose={onClose} />
                );
            }
        });
    }

    deleteConversation = (conversation, e) => {
        let { project } = this.props;
        let projectId = project.projectId;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Delete"
                        okBtnCb={() => {
                            this.props.deleteTestConversation({ projectId, conversationId: conversation.id });
                            onClose();
                        }}
                        type="delete"
                        title="Delete Test Case"
                        message={<div>Are you sure you want to delete <b>{conversation.name}</b> conversation?
                        </div>} />
                );
            }
        });
        cancelEvent(e);
    }

    goToConversation = (conversationName) => {
        const { project, openTestConversation } = this.props;
        openTestConversation({
            project,
            conversationName,
        });
    }

    importAndExportTestCases = () => {
        const { project, exportTestConversations } = this.props;

        this.setState({ treeExporting: true });

        exportTestConversations({
            project,
        }).then((conversations) => {
            this.setState({ treeExporting: false });
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <ExportImportTestCasesPanel
                            project={project}
                            conversations={conversations}
                            onClose={() => {
                                onClose();
                            }}
                            importTestConversations={this.props.importTestConversations} />
                    );
                }
            });
        });
    }

    addNewConversation = () => {
        let { project } = this.props;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <NewTestConversationForm
                        onClose={onClose}
                        addNewConversation={(name) => {
                            this.props.createTestConversation({
                                projectId: project.projectId,
                                name: name
                            });
                        }} />
                );
            }
        });
    }

    onDrop = ({ addedIndex, removedIndex }) => {
        const { project, reorderConversations } = this.props;
        const { conversations } = this.state;

        let newConversations = applyDrag(conversations, addedIndex, removedIndex);
        let oldConversationIds = getArrayHash(conversations, ['id']);
        let newConversationIds = getArrayHash(newConversations, ['id']);

        if (oldConversationIds !== newConversationIds) {
            this.setState({ conversations: newConversations });
            reorderConversations({
                projectId: project.projectId,
                conversationIds: newConversations.map(conversation => conversation.id)
            });
        }
    }

    toggleShowingExpectedResponses = () => {
        const {
            expectedResponsesAreShownGlobally,
            hideExpectedResponses,
            showExpectedResponses
        } = this.props;
        if (expectedResponsesAreShownGlobally) {
            hideExpectedResponses();
        } else {
            showExpectedResponses();
        }
    }

    toggleCommands = () => {
        const {
            commandsInTestModeAreShownGlobally,
            showCommandsInTestMode,
            hideCommandsInTestMode
        } = this.props;
        if (commandsInTestModeAreShownGlobally) {
            hideCommandsInTestMode();
        } else {
            showCommandsInTestMode();
        }
    }

    render() {
        const {
            project,
            conversationName,
            environment,
            expectedResponsesAreShownGlobally,
            commandsInTestModeAreShownGlobally,
            refreshingIsInProcess,
            isDialogsRefreshingInProcess,
            isOneDialogRefreshingInProcess
        } = this.props;
        const {
            conversations,
            treeExporting
        } = this.state;

        const isLastTag = projectHelper.isLastTag(project, this.props[`selected${capitalize(environment)}TagId`]);

        const disabledContentClass = (refreshingIsInProcess || isDialogsRefreshingInProcess || isOneDialogRefreshingInProcess) ? 'disabled' : '';

        return (
            <div className="test-cases-panel">
                <ProjectLeftPanel hasData={project && project.projectId}>
                    <ProjectLeftPanelTitle title="Test Cases" addBtn={
                        <ProjectLeftPanelAddBtn
                            className={disabledContentClass}
                            display={true}
                            title="Add"
                            onClick={this.addNewConversation} />
                    } />

                    <ProjectLeftPanelList className={disabledContentClass}>
                        <Container dragClass="drag-ghost"
                            dropClass="drop-ghost"
                            lockAxis="y"
                            onDrop={this.onDrop}>
                            {conversations.map(conversation => {
                                return (
                                    <Draggable key={conversation.id} >
                                        <ProjectLeftPanelListItem selected={conversation.name === conversationName}>
                                            <ConversationItem
                                                conversation={conversation}
                                                conversationName={conversationName}
                                                renameConversation={this.renameConversation}
                                                deleteConversation={this.deleteConversation}
                                                goToConversation={this.goToConversation}
                                                runDialog={this.props.runDialog}
                                                stopDialog={this.props.stopDialog}
                                                refreshingDialogs={this.props.refreshingDialogs}
                                                dialogsInfo={this.props.dialogsInfo}
                                            />
                                        </ProjectLeftPanelListItem>
                                    </Draggable>
                                );
                            })}
                        </Container>
                    </ProjectLeftPanelList>
                    <ProjectLeftPanelBottomPanel>
                        {isLastTag &&
                            <GitHubIntegrationWrapper>
                                <GitHubRepoPanel
                                    className={disabledContentClass}
                                    environment={environment}
                                    projectId={project.projectId}
                                    project={project} />
                            </GitHubIntegrationWrapper>}
                        {treeExporting && <ProgressLoader position="top" style={{ top: '0px' }} />}
                        <FilterSwitcher
                            className={`test-mode-panel__expecter-responses-toggler ${disabledContentClass}`}
                            labelIfTrue="Show Expected Responses"
                            labelIfFalse="Show Expected Responses"
                            offMode={true}
                            minWidth="220px"
                            maxWidth="220px"
                            onClick={this.toggleShowingExpectedResponses}
                            value={expectedResponsesAreShownGlobally} />

                        <FilterSwitcher
                            className={`test-mode-panel__expecter-responses-toggler ${disabledContentClass}`}
                            labelIfTrue="Show Commands"
                            labelIfFalse="Show Commands"
                            offMode={true}
                            minWidth="220px"
                            maxWidth="220px"
                            onClick={this.toggleCommands}
                            value={commandsInTestModeAreShownGlobally} />

                        <RunAllButton />

                        <div
                            className={`test-cases-panel_conversations_import action-btn dark-with-blue-border middle width-100p ${treeExporting && 'disabled'} ${disabledContentClass}`}
                            onClick={this.importAndExportTestCases}>
                            Import / Export
                        </div>
                    </ProjectLeftPanelBottomPanel>
                </ProjectLeftPanel>
            </div>
        );
    }
}


function mapStateToProps({ testMode }) {
    return {
        expectedResponsesAreShownGlobally: testMode.expectedResponsesAreShownGlobally,
        commandsInTestModeAreShownGlobally: testMode.commandsInTestModeAreShownGlobally,
        refreshingIsInProcess: testMode.refreshingIsInProcess,
        isDialogsRefreshingInProcess: testMode.isDialogsRefreshingInProcess,
        isOneDialogRefreshingInProcess: testMode.isOneDialogRefreshingInProcess,
        refreshingDialogs: testMode.refreshingDialogs,
        dialogsInfo: testMode.dialogsInfo,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openTestConversation: (param) => asyncDispatch(actions.openTestConversation, dispatch, param),
        createTestConversation: (param) => asyncDispatch(actions.createTestConversation, dispatch, param),
        updateTestConversation: (param) => asyncDispatch(actions.updateTestConversation, dispatch, param),
        deleteTestConversation: (param) => asyncDispatch(actions.deleteTestConversation, dispatch, param),
        exportTestConversations: (param) => asyncDispatch(actions.exportTestConversations, dispatch, param),
        importTestConversations: (param) => asyncDispatch(actions.importTestConversations, dispatch, param),
        reorderConversations: (param) => dispatch(actions.reorderConversations(param)),
        reloadProject: () => dispatch(actions.reloadProject()),
        showExpectedResponses: () => dispatch(testModeActions.showExpectedResponses()),
        hideExpectedResponses: () => dispatch(testModeActions.hideExpectedResponses()),
        showCommandsInTestMode: () => dispatch(testModeActions.showCommandsInTestMode()),
        hideCommandsInTestMode: () => dispatch(testModeActions.hideCommandsInTestMode()),
        runDialog: (param) => asyncDispatch(testModeActions.runDialog, dispatch, param),
        stopDialog: (param) => asyncDispatch(testModeActions.stopDialog, dispatch, param),
        stopRunningDialogs: () => asyncDispatch(testModeActions.stopRunningDialogs, dispatch),

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TestCasesPanel);

